/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Erfahrungstufeag11Inputs */



/**

* @param {_Field_Erfahrungstufeag11Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_erfahrungstufeag11 = /** @type {((inputs?: _Field_Erfahrungstufeag11Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Erfahrungstufeag11Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Erfahrungstufe AG 1")
});
export { _field_erfahrungstufeag11 as "_field_erfahrungstufeAg1" }